export default __webpack_public_path__ + "static/media/documents_region_us.86b05297.svg";